export const iconFontAwesomeWritingEnvelopeOpen = (
	<i className="fa-solid fa-envelope-open"></i>
);
